// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__32uZR","footer":"ModalCreateQualiphyProcedure_footer__O7t31","additionData":"ModalCreateQualiphyProcedure_additionData__30DoG"};